export default class ObaNotificacaoModel {
    notificacaoId: string = '';
    blocante: boolean = false;
    disponivelDe: Date = new Date();
    disponivelAte: Date = new Date();
    nome: string = '';
    html: string = '';

    static toModel(notificacoes: any): ObaNotificacaoModel[] {
        return notificacoes.map((n:any) => {
            return {
                notificacaoId: n.notificationId,
                nome: n.title,
                html: n.html,
                blocante: n.blocking === 'true',
                disponivelAte: new Date(`${n.until}T12:00:00.000Z`),
                disponivelDe: new Date(`${n.from}T12:00:00.000Z`),
            } as ObaNotificacaoModel;
        });
    }
}